export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7443_TEAM___': 'TEAM',
    '_11064_FRONTLINE_MI2___': 'Front Line MI2',
    '_11152_TOTAL_DIRECT_REPORTS___': 'Total Direct Reports',
    '_11153_MI2_DATA___': 'MI2 Data',
    '_9879_NO_SCORE___': 'No Score',
    '_11154_IMPROVING___': 'Improving',
    '_11155_DECLINING___': 'Declining',
    '_11156_NO_FRONT_LINE_MI2_DATA___': 'No Front Line MI2 Data is available',
    '_11157_NO_TEAM___': 'No Team',
    '_7495_BACK_TO_PREVIOUS_VIEW___': 'Back to Previous View',
    '_11144_SUPERGROUP_NAME___': 'SuperGroup Name',
    '_11145_DAYS_IN_SUPERGROUP___': 'Days in SuperGroup',
    '_48_MANAGER___': 'Manager',
    '_59_ROLE___': 'Role',
    '_11158_MI2_DETAIL': 'MI2 Detail'
};
